import { StringUtil } from '@root/shared'

import { WalletAssetsTableAddressCell } from './wallet-assets-table-address-cell'
import { WalletAssetsTableBalanceCell } from './wallet-assets-table-balance-cell'
import { WalletAssetsTableBalanceHeader } from './wallet-assets-table-balance-header'
import { WalletAssetsTableCurrencyCell } from './wallet-assets-table-currency-cell'
import { WalletAssetsTableMarketCapCell } from './wallet-assets-table-market-cap-cell'
import { WalletAssetsTablePriceCell } from './wallet-assets-table-price-cell'

import type {
  WalletAssetsColumnId,
  WalletAssetsTableContext,
} from '../../atoms/reatom-wallet-assets-table'
import type { WalletAssetModel } from '@root/entities/wallet'
import type { Column } from '@root/shared/ui-kit'

export const walletAssetsTableColumns: Array<
  Column<WalletAssetModel, WalletAssetsColumnId, WalletAssetsTableContext>
> = [
  {
    id: 'name',
    header: ({ t }) => t('token'),
    render: ({ value }) => <WalletAssetsTableCurrencyCell asset={value} />,
    minWidth: 100,
  },
  {
    id: 'address',
    header: ({ t }) => t('common.address'),
    render: ({ value }) => <WalletAssetsTableAddressCell asset={value} />,
    minWidth: 100,
  },
  {
    id: 'marketCap',
    header: ({ t }) => t('table.market_cap'),
    render: ({ value }) => <WalletAssetsTableMarketCapCell asset={value} />,
    minWidth: 50,
  },
  {
    id: 'balance',
    header: ({ t }) => StringUtil.capitalize(t('common.balance')),
    render: ({ value }) => <WalletAssetsTableBalanceCell asset={value} />,
    width: '1.5fr',
    sortable: true,
  },
  {
    id: 'price',
    header: ({ t }) => t('common.price'),
    renderHeader: (props) => <WalletAssetsTableBalanceHeader {...props} />,
    render: ({ value, context }) => (
      <WalletAssetsTablePriceCell asset={value} wallet={context.wallet} />
    ),
    justify: 'stretch',
    minWidth: 70,
  },
]
